import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { Show, Card, Descriptions } from "@pankod/refine-antd";
import { IUsers } from "interfaces";

export const UsersShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IUsers>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading} title="Detalhes do Usuário">
      <Card 
        title="Informações do Usuário" 
        style={{ 
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Descriptions
          layout="vertical"
          column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
          bordered
          size="small"
        >
          <Descriptions.Item label="ID" span={2}>
            {record?.id}
          </Descriptions.Item>

          <Descriptions.Item label="Nome">
            {record?.name}
          </Descriptions.Item>

          <Descriptions.Item label="Email">
            {record?.email}
          </Descriptions.Item>

          <Descriptions.Item label="Permissões" span={2}>
            {record?.role}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Show>
  );
};